import FlashLib from 'flashlib_onlyplay';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../enums/eAnimationTypes';
import { eSounds } from '../enums/eSounds';

export default class LogoController extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    // this.animations = [
    //   'even_odd',
    //   'jagged_step',
    //   'letters_seq',
    //   'one_two_jagged',
    //   'one_two_smooth',
    //   'smooth_step',
    //   'step_plus',
    //   'words_seq'
    // ]
    // this.animationIndex = 0;
    // this.logoAnimation = animationCreator.createAnimation(eAnimationTypes.LOGO);
    // this.init();
    //
    this.addListeners();
    // this.playAnimation();

  }

  addListeners() {
    window.OPWrapperService.eventManager.add(
      window.OPWrapperService.eventManager.types.EET_SCALE_MANAGER_RESIZE,
      this.onGameResized,
      this
    );
  }

  onGameResized(data) {
    // this.animationPlace.removeChildren();
    data.isLandscape ? this.goToFrame(1) : this.goToFrame(2);
    // this.init();
  }

  getNextAnimationName() {
    this.animationIndex++;
    if (this.animationIndex >= this.animations.length) {
      this.animationIndex = 0;

    }
    return this.animations[this.animationIndex];
  }

  // init() {
  //   this.logoContainer = this.getChildByName('logoContainer');
  //  this.animationPlace = this.logoContainer.getChildByName('animationPlace');
  //   this.animationPlace.addChild(this.logoAnimation);
  // }

  // playAnimation() {
  //   const animationName = this.getNextAnimationName();
  //   this.logoAnimation.state.setAnimation(0, animationName, false);
  //
  //   this.logoAnimation.state.addListener({
  //     complete: () => {
  //       this.logoAnimation.state.setAnimation(0, this.getNextAnimationName(), false);
  //
  //     }
  //   })
  // }

}
